<template>
  <div>
    正在验证 登录中...
  </div>
</template>

<script>
export default {
  mounted() {
    this.checkOAuth();
  },
  methods: {
    checkOAuth() {
      const that = this;
      const state = this.$route.query.state;
      const code = this.$route.query.code;
      if (!code) {
        that.$router.push('/403');
      }

      if (state == 'WECHAT') {
        this.$store.dispatch('session/login_wechat', code).then((wechat)=>{
          if (wechat=='binded') {
            that.$router.push('/core/self');
          } else if (wechat) {
            that.$router.push('/oauth2-binding?wechat='+wechat);
          } else {
            const url = '/core/dashboard';
            that.$router.push(url);
          }
        }).catch((e)=>{
          this.Error(e);
        });
      } else if (state == 'WECHAT-BINDING') {
        this.$store.dispatch('session/');
      } else {
        this.$store.dispatch('session/login_ding', code).then((res)=>{
          const url = '/core/dashboard';
          that.$router.push(url);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
